import { render } from "./Landings.vue?vue&type=template&id=e0d4ffbc&scoped=true"
import script from "./Landings.vue?vue&type=script&lang=js"
export * from "./Landings.vue?vue&type=script&lang=js"

import "./Landings.vue?vue&type=style&index=0&id=e0d4ffbc&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d4ffbc"]])

export default __exports__